import Papa from "papaparse";
import { PropsWithChildren, ReactElement, useEffect, useState } from "react";
import { read, utils } from "xlsx";
import { RendererProps } from "./types";

export function SpreadsheetRenderer({
	url,
	fileType,
	children,
}: PropsWithChildren<RendererProps> & { fileType: string }): ReactElement {
	const [data, setData] = useState<string[][]>([]);

	// FIX:

	useEffect(() => {
		const loadSpreadsheet = async (): Promise<void> => {
			try {
				const response = await fetch(url);
				const blob = await response.blob();

				if (fileType === "csv") {
					const text = await blob.text();
					const result = Papa.parse(text);
					setData(result.data as string[][]);
				} else {
					const buffer = await blob.arrayBuffer();
					const workbook = read(buffer);
					const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
					const jsonData = utils.sheet_to_json(firstSheet, { header: 1 });
					setData(jsonData as string[][]);
				}
			} catch (error) {
				// TODO: handle error
			}
		};

		loadSpreadsheet().catch((error) => {
			// TODO: handle error
		});
	}, [url, fileType]);

	return (
		<>
			<div className="flex h-[calc(90vh-100px)] items-center justify-center">
				<div className="h-full w-full overflow-auto rounded-md bg-white text-black">
					<table className="w-full border-collapse">
						<tbody>
							{data.map((row, rowIndex) => (
								<tr key={`row-${rowIndex}-${row.join("-")}`}>
									{row.map((cell, cellIndex) => (
										<td
											className="border border-surface-inverted p-2"
											key={`cell-${rowIndex}-${cellIndex}-${cell}`}
										>
											{cell}
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
			{children}
		</>
	);
}
